<template>
<v-dialog v-model="showModal" width="400" @click:outside=closeDialog>
      <v-card max-width="400">
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="text-h5 text-medium-emphasis ps-2 title-text" >edit collectible</div>
          <v-btn icon="mdi-close" variant="text" @click=closeDialog></v-btn>
        </v-card-title>
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <v-sheet class="mx-auto" width="300">
            <v-form @submit.prevent ref="form">
              <v-text-field label="id" variant="underlined" class="form_field" v-model="this.currentRow.id" disabled></v-text-field>
              <v-text-field label="identifier" variant="underlined" class="form_field" v-model="this.currentRow.identifier" disabled></v-text-field>
              <v-text-field :rules="[required, numeric]" label="valuation" variant="underlined" class="form_field" v-model="this.currentRow.valuation"></v-text-field>
            </v-form>
          </v-sheet>
        </v-card-text>
        <template v-slot:actions>
          <v-row align="center" justify="end" class="actionsRow">
            <v-btn v-on:click="submitForm" class="mt-2 submit_button" type="submit" block>update</v-btn>
            <v-btn v-on:click="submitDeleteRecord" class="mt-2 submit_button" type="submit" block>delete</v-btn>
          </v-row>
        </template>
      </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';

export default {
  props: {
    show: Boolean,
    currentRow: Object
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    showModal: {
    get () {
      return this.show
    },
  },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async submitForm(e) {
      e.preventDefault();
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      try {

        await axios.request({
          url: "/collectibles/" + this.currentRow.id,
          method: "PUT",
          headers: {
              Authorization: `Bearer ${this.token}`
          },
          data: {
            valuation: this.currentRow.valuation
          }
        });
          this.$parent.getCollectibles(); // update list on local
          this.$emit("close"); // close modal via parent
      } catch (error) {
        this.showSnackbar({ message: 'Failed to update collectible' });
      }
    },
    async submitDeleteRecord(e) {
      try {
        e.preventDefault();
        await axios.delete('/collectibles/' + this.currentRow.id,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
          }
        });
          this.$parent.getCollectibles(); // update list on local
          this.$emit("close"); // close modal via parent

      } catch (error) {
        this.showSnackbar({ message: 'Failed to delete collectible' });
      }
    },
    required (v) {
        return (v !== null && v !== undefined && v !== '') || 'required'
    },
    numeric (v) {
        return !isNaN(v) || 'must be a number'
    },
    closeDialog(){
      this.$parent.getCollectibles();
      this.$emit('close');
    },

  }

}
</script>

<style scoped>

.title-text, .body-text, .form_field, .submit_button {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.actionsRow{
  margin-bottom: 5px;
}

</style>
